import { useEffect, useState } from "react";
import { DashboardPage } from "./pages/dashboard-page";
import { CanvasPage } from "./pages/canvas-page";
import { NotFoundPage } from "./pages/not-found-page";

// 軽量なクライアントサイドルータ。
// React Router を引き込まず、location.pathname を直接観察する。
// パス: / -> ダッシュボード、/c/:canvasId -> キャンバス
export function Router(): JSX.Element {
  const [pathname, setPathname] = useState<string>(() => window.location.pathname);

  useEffect(() => {
    const handler = (): void => {
      setPathname(window.location.pathname);
    };
    window.addEventListener("popstate", handler);
    return () => window.removeEventListener("popstate", handler);
  }, []);

  if (pathname === "/" || pathname === "") {
    return <DashboardPage />;
  }
  const canvasMatch = pathname.match(/^\/c\/([A-Za-z0-9_-]{6,32})\/?$/);
  if (canvasMatch && canvasMatch[1]) {
    return <CanvasPage canvasId={canvasMatch[1]} />;
  }
  return <NotFoundPage />;
}

/**
 * pushState でクライアントサイド遷移を行う。
 * popstate イベントが発火しないため、明示的に dispatchEvent を呼ぶ。
 */
export function navigate(pathname: string): void {
  window.history.pushState({}, "", pathname);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
